import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-My_Account_Icon",
  "use": "icon-My_Account_Icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-My_Account_Icon\">\n  <path id=\"icon-My_Account_Icon_Vector\" d=\"M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm0,22a9.927,9.927,0,0,1-6.441-2.363,6.8,6.8,0,0,1,12.881.01A9.958,9.958,0,0,1,12,22ZM9.306,9.361a2.725,2.725,0,1,1,2.725,2.723A2.727,2.727,0,0,1,9.306,9.361Zm10.648,8.7A8.639,8.639,0,0,0,14.5,13.386a4.726,4.726,0,1,0-4.968-.01,8.69,8.69,0,0,0-5.489,4.666A9.907,9.907,0,0,1,2,12a10,10,0,1,1,17.95,6.057Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/My_Account_Icon.svg
// module id = 92
// module chunks = 0 1 2